<template>
  <div class="container">
    <Shooting v-if="isShowShooting" />
    <Retouch v-if="isShowRetouch" />
    <Render v-if="isShowRender" />
    <Section v-if="isShowSection" />
    <LaunchList v-if="isShowLaunchList" />
    <NewArrivals v-if="isShowNewArrivals" />
    <ProductChange v-if="isShowProductChange" />
  </div>
</template>

<script>
import Shooting from './components/shooting.vue';
import Retouch from './components/retouch.vue';
import Render from './components/render.vue';
import Section from './components/section.vue';
import LaunchList from './components/launchList.vue';
import NewArrivals from './components/newArrivals.vue';
import ProductChange from './components/productChange.vue';

export default {
  name: 'agencyWorkbench',
  components: {
    Shooting,
    Retouch,
    Render,
    Section,
    LaunchList,
    NewArrivals,
    ProductChange,
  },
  computed: {
    permitList() {
      return JSON.parse(localStorage.getItem('permitList'));
    },
    isShowShooting() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#shooting';
      return this.permitList.includes(Jurisdiction);
    },
    isShowRetouch() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#retouch';
      return this.permitList.includes(Jurisdiction);
    },
    isShowRender() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#render';
      return this.permitList.includes(Jurisdiction);
    },
    isShowSection() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#section';
      return this.permitList.includes(Jurisdiction);
    },
    isShowLaunchList() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#launchList';
      return this.permitList.includes(Jurisdiction);
    },
    isShowNewArrivals() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#newArrivals';
      return this.permitList.includes(Jurisdiction);
    },
    isShowProductChange() {
      let Jurisdiction = 'ec-pc-new#ec-pc-new#agencyWorkbench#productChange';
      return this.permitList.includes(Jurisdiction);
    },
  },
};
</script>

<style lang="stylus" scoped>
/* Fonts */
@font-face {
  font-family: 'YinHei';
  src: local('YinHei'), local('Microsoft YaHei');
}

.container {
  width: 100%;
  height: calc(100vh - 65px);
  padding: 5px;
  box-sizing: border-box;
  background: #021814;
  position: relative;
  color: #fff;
  overflow-y: auto;

  &::before {
    content: "";
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    background: url('../../../assets/images/workbench_img/bg.png') no-repeat center;
    background-size: 100% 100%;
    z-index: 0;
  }
}
</style>
